<template>
  <div class="pa-4 text-center">Cerrando sesión…</div>
</template>

<script>
export default {
  name: 'SsoLogout',
  created() {
    localStorage.clear();
    this.$store.dispatch('logout');
    if (window.parent && window.parent !== window) {
      window.parent.postMessage({ type: 'ac-sso-logout', ok: true }, '*');
    }
  },
};
</script>
